module.exports = __webpack_public_path__ + "static/img/main_bj.e46c153.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/product/main_bj.png
// module id = yTXS
// module chunks = 1